import Vue from 'vue'
import Router from 'vue-router'
//避免导航冗余
const routerPush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: 'login',
      component: resolve => (require(['@/components/login'], resolve)),
      meta: {
        active: "登录"
      }
    },
    {
      path: "/register",
      name: 'register',
      component: resolve => (require(['@/components/register'], resolve)),
      meta: {
        active: "注册"
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: resolve => (require(['@/components/agreement'], resolve)),
      meta: {
        active: "注册协议"
      }
    },
    {
      path: '/',
      name: 'index',
      component: resolve => (require(["@/components/index"], resolve)),
      redirect: "/star",
      children: [
        {
          path: "/authentication",
          name: 'authentication',
          component: resolve => (require(['@/components/release/authentication'], resolve)),
          meta: {
            active: "认证大咖"
          }
        },
        {
          path: "/webview",
          name: 'webview',
          component: resolve => (require(['@/components/webview'], resolve)),
          meta: {
            active: "企业介绍"
          }
        },
        {
          path: "/home",
          name: "home",
          component: resolve => (require(['@/components/home'], resolve)),
          meta: {
            active: "首页"
          }
        },
        {
          path: "/star",
          name: "star",
          component: resolve => (require(['@/components/star'], resolve)),
          meta: {
            active: "技术大咖"
          }
        },
        {
          path: "/news",
          name: "news",
          component: resolve => (require(['@/components/news'], resolve)),
          meta: {
            active: "新闻动态"
          }
        },
        {
          path: "/newsinfo",
          name: "newsinfo",
          component: resolve => (require(['@/components/newsinfo'], resolve)),
          meta: {
            active: "新闻详情"
          }
        },
        {
          path: "/demand",
          name: "demand",
          component: resolve => (require(['@/components/demand'], resolve)),
          meta: {
            active: "技术需求"
          }
        },
        {
          path: "/service",
          name: 'service',
          component: resolve => (require(['@/components/service'], resolve)),
          meta: {
            active: "服务商"
          }
        },
        {
          path: "/techlist",
          name: "techlist",
          component: resolve => (require(['@/components/techlist'], resolve)),
          meta: {
            active: "技术包"
          }
        },
        {
          path: "/techinfo",
          name: "techinfo",
          component: resolve => (require(['@/components/techinfo'], resolve)),
          meta: {
            active: "技术包详情"
          }
        },
        {
          path: "/salon",
          name: "salon",
          component: resolve => (require(['@/components/salon'], resolve)),
          meta: {
            active: "线下活动"
          }
        },
        {
          path: "/personalcenter",
          name: 'personalcenter',
          component: resolve => (require(['@/components/personalcenter'], resolve)),
          meta: {
            active: "个人中心"
          }
        },
        {
          path: "/salonadd",
          name: "salonadd",
          component: resolve => (require(['@/components/release/salon'], resolve)),
          meta: {
            active: "发起线下活动"
          }
        },
        {
          path: "/techadd",
          name: "techadd",
          component: resolve => (require(['@/components/release/techadd'], resolve)),
          meta: {
            active: "技术包"
          }
        },
        {
          path: "/demandadd",
          name: 'demandadd',
          component: resolve => (require(['@/components/release/demand'], resolve)),
          meta: {
            active: "发布需求"
          }
        },
        {
          path: '/startadd',
          name: "startadd",
          component: resolve => (require(['@/components/release/start'], resolve)),
          meta: {
            active: "技术大咖注册"
          }
        },
        {
          path: "/serviceadd",
          name: "serviceadd",
          component: resolve => (require(['@/components/release/service'], resolve)),
          meta: {
            active: "服务商注册"
          }
        },
        {
          path: "/docadd",
          name: "docadd",
          component: resolve => (require(['@/components/doc/add'], resolve)),
          meta: {
            active: "文档上传"
          }
        },
        {
          path: "/homeinfo",
          name: "homeinfo",
          component: resolve => (require(['@/components/homeinfo'], resolve)),
          meta: {
            active: "文档详情"
          }
        },
        {
          path: "/starinfo",
          name: 'starinfo',
          component: resolve => (require(['@/components/starinfo'], resolve)),
          meta: {
            active: "技术大咖详情"
          }
        },
        {
          path: "/saloninfo",
          name: 'saloninfo',
          component: resolve => (require(['@/components/saloninfo'], resolve)),
          meta: {
            active: "线下活动详情"
          }
        },
        {
          path: "/demandinfo",
          name: 'demandinfo',
          component: resolve => (require(['@/components/demandinfo'], resolve)),
          meta: {
            active: "需求详情"
          }
        },
        {
          path: '/serviceinfo',
          name: 'serviceinfo',
          component: resolve => (require(['@/components/serviceinfo'], resolve)),
          meta: {
            active: "服务商详情"
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js